import { menuFirsts } from "../../constants/menu";
import ListEmployees from "../../page/employees/list/list";

const routeEmployees = [
    {
      ...menuFirsts.EMPLOYEES,
      key: menuFirsts.EMPLOYEES.key,
      name: menuFirsts.EMPLOYEES.name,
      code: menuFirsts.EMPLOYEES.code,
      textName: menuFirsts.EMPLOYEES.textName,
      active: false,
      appBar: true,
      component: ListEmployees
    } ,
    
]

export default routeEmployees